import { useIntl } from '@capsicum/common';
import { useMainCurrenciesQuery } from '@capsicum/socios-core';

export const useNCWFallbackBalance = () => {
	const { $t } = useIntl();

	//retrieve the user's alternate currency
	const { data: currencies } = useMainCurrenciesQuery();
	const altShortCode = currencies?.altCurrency?.shortCode ?? 'EUR';

	return {
		fallbackBalanceDescription: $t('ncWallet.home.fallbackBalanceDescription'),
		fallbackBalanceTitle: '-- ' + altShortCode
	};
};
